import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess<string>, UpdateCartApiParameter, CartResult>;

export const PopulateApiParameterExtended: HandlerType = props => {
    const state = props.getState();
    // const cartId = state.pages?.checkoutReviewAndSubmit?.cartId;
    // const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    // const deliveryDate = state.pages.checkoutReviewAndSubmit.requestedDeliveryDate;
    const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");
    const {
        pages: {
            checkoutReviewAndSubmit: { cartId, requestedDeliveryDate, requestedPickupDate },
        },
    } = state;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const tempDeliveryDate =
    typeof requestedDeliveryDate !== "undefined" ? requestedDeliveryDate : cart.requestedDeliveryDateDisplay;
const tempPickupDate =
    typeof requestedPickupDate !== "undefined" ? requestedPickupDate : cart.requestedPickupDateDisplay;

    props.apiParameter = {
        cart: {
            ...cart,
            status: "AwaitingApproval",
            requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
            requestedPickupDate: convertDateToApiFormat(tempPickupDate),
        },
    };
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
